import axios from '@/plugins/axios'
import format from 'date-fns/format'
import subWeeks from 'date-fns/subWeeks'

export default {
  namespaced: true,

  state: {
    data_loading: false,
    tracks: [],
    campaign_track: [],
    dialog: false,
    dialog_type: '',
    page: 1,
    page_size: 10,
    track_image: null,
    order_column: 'published_at_utc',
    order_type: 'desc',
    track: {},
    image: null,
    report_loading: false,
    // date_range is last week by default
    date_range: [
      format(subWeeks(new Date(), 1), 'yyyy-MM-dd'),
      format(new Date(), 'yyyy-MM-dd')
    ],
    report: {
      downloads: {
        labels: [],
        sum: 0,
        datasets: [
          {
            label: 'Downloads',
            backgroundColor: 'green',
            borderColor: 'red',
            fill: false,
            data: []
          }
        ]
      },
      previews: {
        labels: [],
        sum: 0,
        data: [],
        datasets: [
          {
            label: 'Previews',
            backgroundColor: 'red',
            borderColor: 'green',
            fill: false,
            data: []
          }
        ]
      },
      previews_territories: {
        labels: [],
        data: [],
        datasets: [
          {
            label: 'Previews by Country',
            backgroundColor: 'purple',
            borderColor: 'gold',
            fill: false,
            data: []
          }
        ]
      },
      downloads_territories: {
        labels: [],
        data: [],
        datasets: [
          {
            label: 'Downloads by Country',
            backgroundColor: 'blue',
            borderColor: 'gold',
            fill: false,
            data: []
          }
        ]
      },
      downloads_by_channel: []
    },
    pdf_report: {},
    campaign_pdf_report:  {},
    challenge_type:'',
    genres: [],
    moods: [],
    restrictions: [],
    socials: [],
    pricing:[],
    PieChartSettPdf: {
      width: 'auto',
      height: 290,
      is3D: false,
      pieSliceText: 'value',
      fontName: 'Nunito Bold',
      pieSliceTextStyle: {
        color: '#fff',
        fontSize: 15
      },
      legend: 'none',
      pieHole: 0.5,
      chartArea: {
        width: '90%',
        height: '90%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 14
        },
        showColorCode: true
      },
      colors: [
        '#4472C4',
        '#8687D2',
        '#B69FDF',
        '#DEBAEB',
        '#A9DAE7',
        '#A7E5FF',
        '#00CAFF',
        '#00F2EA',
        '#00D3A5',
        '#00FF00',
      ]
    }
  },

  mutations: {
    setTracks(state, payload) {
      state.tracks = payload
    },
    setTrack(state, payload) {
      state.track = payload
      if (state.track.timing_start)
        state.track.timing = [payload.timing_start, payload.timing_end]
    },
    setTiming(state, payload) {
      state.track.timing = [payload.date_start, payload.date_end]
      state.track.date_start = payload.date_start
      state.track.date_end = payload.date_end
    },
    setTrackDownloads(state, payload) {
      state.report.downloads.labels = payload.label
      state.report.downloads.datasets[0].data = payload.value
      state.report.downloads.sum = payload.value.reduce((a, b) => a + b, 0)
    },
    setTrackPreviews(state, payload) {
      state.report.previews.labels = payload.label
      state.report.previews.datasets[0].data = payload.value
      state.report.previews.sum = payload.value.reduce((a, b) => a + b, 0)
    },
    setTrackDownloadsTerritories(state, payload) {
      state.report.downloads_territories.labels = payload.label
      state.report.downloads_territories.datasets[0].data = payload.value
    },
    setTrackPreviewsTerritories(state, payload) {
      state.report.previews_territories.labels = payload.label
      state.report.previews_territories.datasets[0].data = payload.value
    },
    setTrackDownloadsByChannel(state, payload) {
      state.report.downloads_by_channel = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setDialog(state, { status, type }) {
      state.dialog = status
      state.dialog_type = type
    },
    setDataLoading(state, payload) {
      state.data_loading = payload
    },
    setReportLoading(state, payload) {
      state.report_loading = payload
    },
    setTrackImage(state, payload) {
      state.track_image = payload
    },
    setArtist(state, payload) {
      state.track.artist_id = payload
    },
    setPdfReport(state, payload) {
      state.pdf_report = payload
      state.challenge_type = 'YouTube'
    },
    setPdfShortsReport(state, payload) {
      state.campaign_pdf_report = payload
      state.challenge_type = 'Shorts'
    },
    setPdfTikTokReport(state, payload) {
      state.campaign_pdf_report = payload
      state.challenge_type = 'TikTok'
    },
    setPdfInstagramReport(state, payload) {
      state.campaign_pdf_report = payload
      state.challenge_type = 'Instagram'
    },
    setCampaignTrack(state, payload) {
      state.campaign_track = payload
    },
    setMoods(state, payload) {
      state.moods = payload
    },
    setGenres(state, payload) {
      state.genres = payload
    },
    setRestrictions(state, payload) {
      state.restrictions = payload
    },
    setTrackSmartLinks(state, payload) {
      state.track.smartLinks = payload
    },
    setSocials(state, payload) {
      state.socials = payload.filter(social => {
        return ['YouTube', 'YouTube Short', 'TikTok', 'Instagram'].includes(social.name)
      })
    },
    setPricing(state, payload) {
      state.pricing = payload
    },
    setImage(state, payload) {
      state.image = payload
    },
  },

  actions: {
    read({ commit, state }, filters = null) {
      commit('setDataLoading', true)

      let ls = localStorage.getItem('track_new_releases_filter')
      filters = JSON.parse(ls)

      axios.admin
        .get('talent-scout/track', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          commit('setTracks', r.data)
          commit('setDataLoading', false)
        })
        .catch(() => {
          commit('setDataLoading', false)
        })
    },

    readCampaignTrack({ commit }, id) {
      axios.admin
        .get(`talent-scout/track/${id}/campaign`)
        .then(r => {
          commit('setCampaignTrack', r.data.data)
          commit('setDataLoading', false)
        })
        .catch(() => {
          commit('setDataLoading', false)
        })
    },

    readReport({ commit, state }, id) {
      commit('setReportLoading', true)
      axios.admin
        .get(`report/track/${id}`, {
          params: {
            date_start: state.date_range[0],
            date_end: state.date_range[1]
          }
        })
        .then(r => {
          commit('setTrackDownloads', r.data.downloads)
          commit('setTrackPreviews', r.data.previews)
          commit('setTrackDownloadsTerritories', r.data.downloads_territories)
          commit('setTrackPreviewsTerritories', r.data.previews_territories)
          commit('setTrackDownloadsByChannel', r.data.downloads_by_channel)
          commit('setReportLoading', false)
        })
        .catch(() => {
          commit('setReportLoading', false)
        })
    },

    readPdfReport({ commit }, send) {
      return new Promise((resolve, reject) => {
        axios.api
          .get(`report/campaign/${send.id}`, {
            params: {
              gp: send.guaranteed_payment,
              shoutout: send.shoutout,
              publish_date: send.publish_date,
            }
          })
          .then(r => {
            commit('setPdfReport', r.data.data)
            resolve()
          })
          .catch(e => {
            console.log(e)
            reject(e)
          })
      })
    },
    readShortsReport({ commit }, send) {
      return new Promise((resolve, reject) => {
        axios.api
          .get(`report/challenge/shorts/${send.id}`, {
            params: {
              type: 'track',
            }
          })
          .then(r => {
            commit('setPdfShortsReport', r.data.data)
            resolve()
          })
          .catch(e => {
            console.log(e)
            reject(e)
          })
      })
    },
    readTikTokReport({ commit }, send) {
      return new Promise((resolve, reject) => {
        axios.api
          .get(`report/challenge/tiktok/${send.id}`, {
            params: {
              type: 'track',
            }
          })
          .then(r => {
            commit('setPdfTikTokReport', r.data.data)
            resolve()
          })
          .catch(e => {
            console.log(e)
            reject(e)
          })
      })
    },
    readInstagramReport({ commit }, send) {
      return new Promise((resolve, reject) => {
        axios.api
          .get(`report/challenge/instagram/${send.id}`, {
            params: {
              type: 'track',
            }
          })
          .then(r => {
            commit('setPdfInstagramReport', r.data.data)
            resolve()
          })
          .catch(e => {
            console.log(e)
            reject(e)
          })
      })
    },
    create({ dispatch, commit, state }) {
      axios.admin
        .post('talent-scout/track', {
          title: state.track.title,
          artist_id: state.track.artist_id,
          song_length: state.track.song_length,
          file_name: state.track.file_name,
          keywords: state.track.keywords
        })
        .then(() => {
          dispatch('read', {
            page: state.page,
            page_size: state.page_size
          })
          commit('setDialog', false)
        })
    },

    update({ dispatch, commit, state }, id) {
      axios.admin
        .put(`talent-scout/track/${id}`, {
          id: state.track.id,
          title: state.track.title,
          featured: state.track.featured,
          leaderboard: state.track.leaderboard,
          affiliate_track_generator: state.track.affiliate_track_generator,
          affiliate_signup_generator: state.track.affiliate_signup_generator,
          artist_id: state.track.artist_id,
          timing: state.track.timing,
          track_genres: state.track.track_genres,
          moods: state.track.moods,
          bpm: state.track.bpm,
          ffm_link: state.track.ffm_link,
          description: state.track.description,
          card_bar_desc: state.track.card_bar_desc,
          smartLinks: state.track.smartLinks,
          restrictions: state.track.restrictions,
          socials: state.track.socials,
          nft_description: state.track.nft_description,
          tiktok_pricing:state.track.tiktok_pricing,
          instagram_pricing:state.track.instagram_pricing,
          short_pricing:state.track.short_pricing,
          image_url:  state.track.image_url,
          image:  state.image,
          short_challenge: state.track.short_challenge,
          tiktok_challenge: state.track.tiktok_challenge,
          instagram_challenge: state.track.instagram_challenge,
          regular_challenge: state.track.regular_challenge,
        })
        .then(() => {
          commit('setDialog', false)
          dispatch('read', {
            page: state.page,
            page_size: state.page_size
          })
        })
    },

    publishTrack({ dispatch, state }, id) {
      axios.admin.put('talent-scout/track/publish/' + id).then(() => {
        dispatch('read', {
          page: state.page,
          page_size: state.page_size
        })
      })
    },

    unpublishTrack({ dispatch, state }, id) {
      axios.admin.put('talent-scout/track/unpublish/' + id).then(() => {
        dispatch('read', {
          page: state.page,
          page_size: state.page_size
        })
      })
    },

    uploadImage({ dispatch, commit, state }, image) {
      axios.admin.post('talent-scout/track/image', image).then(r => {
        dispatch('read', {
          page: state.page,
          page_size: state.page_size
        })
        commit('setTrackImage', r.data.response.message)
      })
    }
  },

  getters: {
    track_data: state => {
      let result = []
      if(!state.tracks.data) return result
      result = state.tracks.data.filter(
        (d, i, s) => i === s.findIndex(t => t.id === d.id)
      )

      return state.tracks.data
    },
    track_campaigns: state => {
      let result = []
      if(!state.tracks.data) return result
      state.tracks.data.map(s => {
        result.push([
          s.id,
          s.campaign_id,
          s.campaign_track_start,
          s.campaign_track_end
        ])
      })
      return result
    },
    countries_chart: state => {
      let result = []
      if (state.campaign_pdf_report.countries) {
        result = [['Task', 'Hours per Day']]
        state.campaign_pdf_report.countries.map(s => {
          result.push([s.country, Number(s.count)])
        })
      }
      return result
    },
  }
}
